module.exports = __webpack_public_path__ + "static/media/speech-bubble-mask.227250e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/speech-bubble-mask.svg
// module id = 1909
// module chunks = 0